import type { WavespeedSpeechModelConfig } from '../types';

export const murekaConfigs: Record<string, WavespeedSpeechModelConfig> = {
  'mureka-v9.5-prompt-to-song': {
    // https://wavespeed.ai/zh-CN/models/mureka-ai/mureka-v9.5/prompt-to-song
    apiPath: '/mureka-ai/mureka-v9.5/prompt-to-song',
    enableTranslation: false,
    buildInput: ({ text, providerOptions }) => {
      return {
        prompt: text,
        styles: Array.isArray(providerOptions?.styles) ? providerOptions.styles : undefined,
        output_format: typeof providerOptions?.output_format === 'string' ? providerOptions.output_format : 'mp3',
        reference_id: undefined,
        vocal_id: undefined,
      };
    },
  },
  'mureka-v9.5-generate-song': {
    // https://wavespeed.ai/zh-CN/models/mureka-ai/mureka-v9.5/generate-song
    apiPath: '/mureka-ai/mureka-v9.5/generate-song',
    enableTranslation: false,
    buildInput: ({ text, providerOptions }) => {
      return {
        lyrics: providerOptions?.lyrics || '',
        prompt: text || undefined,
        output_format: typeof providerOptions?.output_format === 'string' ? providerOptions.output_format : 'mp3',
        reference_id: undefined,
        vocal_id: undefined,
        melody_id: undefined,
      };
    },
  },
  'mureka-v9.5-generate-bgm': {
    // https://wavespeed.ai/zh-CN/models/mureka-ai/mureka-v9.5/generate-bgm
    apiPath: '/mureka-ai/mureka-v9.5/generate-bgm',
    enableTranslation: false,
    buildInput: ({ text, providerOptions }) => {
      return {
        prompt: text,
        output_format: typeof providerOptions?.output_format === 'string' ? providerOptions.output_format : 'mp3',
      };
    },
  },
};
